import { useRef } from 'react'
import { useCrmIntegrationChatAvailability } from '@/hooks/useCrmIntegrationChatAvailability'
import { useCrmIntegrationChatUserAccess } from '@/hooks/useCrmIntegrationChatUserAccess'
import debounce from '@/utils/debounce/debounce'
import {
  CRM_REALTIME_CHAT_REFETCH_DEBOUNCE_MS,
  useRefetchOnBrowserTabVisible,
} from '@pages/Admin/CRM/utils/crmRealtimeWebSocket'

type UseCrmIntegrationChatsListBrowserTabVisibleRefetchParams = {
  enabled?: boolean
  silentRetry: () => void
  onSync?: () => void
}

/** Возврат на вкладку браузера при открытом списке CRM-чатов — тихий refetch. */
export const useCrmIntegrationChatsListBrowserTabVisibleRefetch = ({
  enabled = true,
  silentRetry,
  onSync,
}: UseCrmIntegrationChatsListBrowserTabVisibleRefetchParams): void => {
  const { isLoading, hasAnyConnected } = useCrmIntegrationChatAvailability()
  const hasUserAccess = useCrmIntegrationChatUserAccess()

  const silentRetryRef = useRef(silentRetry)
  silentRetryRef.current = silentRetry

  const onSyncRef = useRef(onSync)
  onSyncRef.current = onSync

  const debouncedSilentRetryRef = useRef(
    debounce(() => {
      silentRetryRef.current()
      onSyncRef.current?.()
    }, CRM_REALTIME_CHAT_REFETCH_DEBOUNCE_MS),
  )

  const canSyncChatsList =
    enabled &&
    !isLoading &&
    hasAnyConnected &&
    hasUserAccess

  useRefetchOnBrowserTabVisible(() => {
    debouncedSilentRetryRef.current()
  }, canSyncChatsList)
}
